import Image from "next/image";
import { HANDPRINT_PATH, HANDPRINT_VIEWBOX } from "./paintPaths";

const art = {
  sun: { src: "/images/doodles/sun.png", w: 219, h: 155 },
  rocket: { src: "/images/doodles/rocket.png", w: 191, h: 155 },
  kite: { src: "/images/doodles/kite.png", w: 171, h: 145 },
  flower: { src: "/images/doodles/flower-teal.png", w: 120, h: 115 },
  flowerGrass: { src: "/images/doodles/flower-grass.png", w: 157, h: 179 },
  flowersGrass: { src: "/images/doodles/flowers-grass.png", w: 352, h: 156 },
  worm: { src: "/images/doodles/caterpillar.png", w: 340, h: 176 },
  bee: { src: "/images/doodles/bee.png", w: 186, h: 158 },
  apple: { src: "/images/doodles/apple.png", w: 171, h: 155 },
  bus: { src: "/images/doodles/bus.png", w: 288, h: 202 },
  blocks: { src: "/images/doodles/blocks.png", w: 183, h: 182 },
  girl: { src: "/images/doodles/girl.png", w: 181, h: 217 },
  trail: { src: "/images/doodles/trail-teal.png", w: 313, h: 215 },
  trail2: { src: "/images/doodles/trail-teal-2.png", w: 305, h: 209 },
  trailYellow: { src: "/images/doodles/trail-yellow.png", w: 66, h: 198 },
} as const;

type ArtType = keyof typeof art;

const legacy = {
  plane: "kite",
  car: "bus",
  cube: "blocks",
  child: "girl",
  handprints: "handprint",
} as const;

type DoodleProps = {
  type: ArtType | keyof typeof legacy | "handprint";
  className?: string;
  /** rendered width in px */
  size?: number;
};

export default function Doodle({ type, className = "", size = 110 }: DoodleProps) {
  const base = `pointer-events-none absolute select-none ${className}`;
  const resolved = type in legacy ? legacy[type as keyof typeof legacy] : (type as ArtType | "handprint");

  if (resolved === "handprint") {
    // paint handprint traced from the approved mockup, tinted via text colour classes
    return (
      <span aria-hidden="true" className={base}>
        <svg viewBox={HANDPRINT_VIEWBOX} width={size} height={size * 1.05} fill="currentColor">
          <path d={HANDPRINT_PATH} />
        </svg>
      </span>
    );
  }

  const a = art[resolved];
  return (
    <span aria-hidden="true" className={base}>
      <Image src={a.src} alt="" width={size} height={Math.round((size * a.h) / a.w)} />
    </span>
  );
}
